import {
  IconButton,
  ListItem,
  ListItemIcon,
  ListItemText,
} from '@mui/material';
import React from 'react';
import MenuOption from './MenuOption';
import { useNavigate, useLocation } from 'react-router-dom';

interface SideMenuItemProps {
  menuItem: MenuOption;
  showChildren(): void;
  child: Boolean;
  keyName: string;
}

function SideMenuItem({
  menuItem,
  showChildren,
  child,
  keyName,
}: SideMenuItemProps) {
  const navigate = useNavigate();

  const location = useLocation();

  return (
    <ListItem
      key={keyName}
      sx={(theme) => ({
        color: theme.palette.primary.main,
        cursor: 'pointer',
        ...(location.pathname === menuItem.route && {
          borderRight: '4px',
          borderStyle: 'solid',
          borderColor: '#FFFFFF',
          opacity: 1,
          backgroundColor: theme.palette.primary.light,
        }),
      })}
      onClick={() =>
        menuItem.route ? navigate(menuItem.route) : showChildren()
      }>
      {menuItem.icon && (
        <ListItemIcon sx={(theme) => ({ color: theme.palette.action.active })}>
          {React.createElement(menuItem.icon)}
        </ListItemIcon>
      )}
      <ListItemText
        primary={menuItem.name}
        primaryTypographyProps={{
          variant: child ? 'body1' : 'overline',
          color: child ? 'text.primary' : 'text.secondary',
        }}
      />
      {!menuItem.route && (
        <IconButton
          color="inherit"
          aria-label="open drawer"
          onClick={() => showChildren()}
          edge="start"
          size="large">
          {/* {!open && <ArrowDropDownIcon />}
          {open && <ArrowDropUpIcon />} */}
        </IconButton>
      )}
    </ListItem>
  );
}

export default SideMenuItem;
